import React, { useRef } from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";

const Phase1 = () => {
  const container = useRef();

  useGSAP(() => {
    gsap.utils.toArray(".phase-section").forEach((section) => {
      gsap.from(section.querySelectorAll("li"), {
        x: -50,
        opacity: 0,
        duration: 0.5,
        stagger: 0.05,
        ease: "power2.out",
        scrollTrigger: {
          trigger: section,
          start: "top 70%",
        }
      });

      gsap.from(section.querySelector(".phase-img"), {
        x: 100,
        opacity: 0,
        duration: 0.8,
        ease: "power3.out",
        scrollTrigger: {
          trigger: section,
          start: "top 60%",
        }
      });
    });
  }, { scope: container });

  const PhaseItem = ({ number, points, imgSrc }) => (
    <div className="phase-section flex flex-col lg:flex-row lg:p-20 p-5 mt-10 justify-center items-center lg:min-h-[60vh] min-h-[40vh] border-b border-white/5 last:border-0 overflow-hidden">
      <div className="lg:w-[60%] lg:pr-20 pr-0">
        <h1 className="text-transparent bg-clip-text bg-gradient-to-r from-[#faca6d] to-[#fa78f2] lg:text-2xl text-xl font-black mb-6 tracking-tighter">
          PHASE {number}
        </h1>
        <ul className="space-y-6 text-left text-2xl text-slate-300">
          {points.map((p, i) => (
            <li key={i} className="flex gap-4 items-start">
              <span className="w-2 h-2 rounded-full bg-[#fa78f2] mt-3 flex-shrink-0" />
              {p}
            </li>
          ))}
        </ul>
      </div>
      <div className="lg:w-[40%] mt-12 lg:mt-0 overflow-hidden rounded-[2.5rem] shadow-2xl phase-img group">
        <img
          src={imgSrc}
          alt={`Phase ${number}`}
          className="w-full h-full object-cover transform transition-transform duration-1000 group-hover:scale-110"
        />
      </div>
    </div>
  );

  return (
    <div id="roadmap" ref={container} className="relative lg:py-32 py-16 bg-slate-950/20">
      <h1 className="text-center text-4xl font-black mb-20 text-transparent bg-clip-text bg-gradient-to-r from-violet-500 to-fuchsia-500 tracking-tighter uppercase italic">
        Roadmap
      </h1>
      
      <PhaseItem 
        number="1" 
        points={[
          "Horizen dai dai harmony dogecoin waves nexo.",
          "Flow horizen waves dash tether zcash waves dash terraUSD.",
          "Quant harmony amp cosmos PancakeSwap decentraland decred.",
          "Serum TRON solana tether holo crypto. Flow eCash amp EOS digibyte stellar."
        ]}
        imgSrc="/phase1.png"
      />

      <PhaseItem 
        number="2" 
        points={[
          "BitTorrent dai dogecoin crypto nexo nexo cosmos tezos ox PancakeSwap.",
          "Tether ethereum helium eCash IOTA. Litecoin enjin shiba-inu dash audius monero.",
          "Aave PancakeSwap loopring horizen neo uniswap avalanche litecoin celsius TRON.",
          "Hive stellar velas flow cardano."
        ]}
        imgSrc="/phase2.png"
      />

      <PhaseItem 
        number="3" 
        points={[
          "Revain audius bitcoin revain PancakeSwap elrond ipsum ethereum.",
          "Waves TRON dogecoin bancor eCash quant secret.",
          "Celsius crypto bancor nexo litecoin decentraland crypto."
        ]}
        imgSrc="/phase3.png"
      />
    </div>
  );
};

export default Phase1;
